function Select(props) {
  return (
    <div
      className={
        'rtds-input-field rtds-select-field rtds-gap-1 ' +
        (props.classDiv ?? '')
      }
      hidden={props.hidden}
    >
      <label
        htmlFor={props.id}
        className={'rtds-input-field__label ' + props.classLabel}
      >
        {props.label}
        {props.required ? ' ' : ''}
        <abbr
          hidden={!props.required}
          className='rtds-font-bold rtds-no-underline'
          title='obbligatorio'
        >
          *
        </abbr>
      </label>

      <div
        className={
          (props.classDivSelect ?? 'rtds-select') +
          (props.inputErrors?.includes(props.id) ? ' has-error' : '')
        }
      >
        <select
          required={!!props.required}
          id={props.id}
          name={props.id}
          className={
            props.classSelect + ((!props.options || props.loadingData || props.disabled || props.readOnly) ? ' rtds-background-02' : '')
          }
          aria-describedby= {props.inputErrors?.includes(props.id) ? (props.id + 'Error') : null}
          onChange={(event) => props.onChange(event)}
          aria-invalid={props.inputErrors?.includes(props.id)}
          value={props.value}
          disabled={!props.options || props.disabled || props.readOnly}
          hidden={props.hidden}
          title={props.title}
        >
          {props.baseOption && <option value=''>{props.baseOption}</option>}
          {
            props.options?.map((opt) => (
              <option
                key={props.id + opt[props.bindKey ?? 'key']}
                value={opt[props.bindKey ?? 'key']}
              >
                {opt[props.bindValue ?? 'value']}&emsp;
              </option>
            ))
          }
        </select>
        {
          props.inputErrors?.includes(props.id) && 
          <svg
            className='rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 rtds-absolute rtds-right-8 rtds-content-placeholder rtds-content-error'
            aria-hidden='true'
            focusable='false'
            role='img'
          >
            <use
              xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#outline--exclamation-circle`}
            />
          </svg>
        }

        {
          ((!props.options || props.loadingData) && !props.hideSpinnerLoading) && 
          <svg
            className='rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 rtds-absolute rtds-right-8 rtds-animate-spin rtds-background-01'
            aria-hidden='true'
            focusable='false'
            role='img'
          >
            <use xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#spinner`} />
          </svg>
        }

        {/* <span className='rtds-sr-only'>Caricamento...</span> */}
      </div>

      <span
        className='rtds-input-field__hint'
        hidden={!props.inputErrors?.includes(props.id)}
      >
        <span
          className='rtds-input-field__error'
          id={props.id + 'Error'}
          aria-live='assertive'
        >
          {props.errorMessage ?? 'Campo obbligatorio'}
        </span>
      </span>
    </div>
  );
}

export default Select;
